<template>
  <div class="w-full h-full">
    <slot />
  </div>
</template>

<script>
import * as _ from 'lodash'
import { EVENT_OBSERVERS } from '@state/modules/event-observer'
import { EVENT } from '@games/constant'
import { ANSWER } from '@src/games/constant'

export default {
  props: {
    events: {
      type: Array,
      required: true,
    },
    elements: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  mounted() {
    this.$store.dispatch(EVENT_OBSERVERS.NAMESPACE(EVENT_OBSERVERS.SET_SETTING), {
      events: this.events,
      elements: this.elements,
    })

    for (const event of this.events) {
      this.$log.debug(`listen on [${event}]`)
      this.$el.addEventListener(event, this.capture)
    }
  },
  beforeDestroy() {
    this.$store.dispatch(EVENT_OBSERVERS.NAMESPACE(EVENT_OBSERVERS.CLEAR))
    for (const event of this.events) {
      this.$log.debug(`listen off [${event}]`)
      this.$el.removeEventListener(event, this.capture)
    }
  },
  methods: {
    capture(event) {
      this.$events.emit(EVENT.OBSERVER_CAPTURE, { event })

      const node = _.toLower(_.get(event, 'detail.element', event.target.nodeName))
      const dataset = _.get(event, 'target.dataset')
      this.$log.debug('captured event : ', node, event.type)

      // 이벤트가 필터 요구된 요소 인지 체크
      const inside = this.elements
        ? _(this.elements)
            .map(_.toLower)
            .find((v) => v === node || _.includes(dataset, v))
        : true

      // YES / NO
      inside ? this.inside(event) : this.outside(event)

      // 트리거 무시된 요소 체크
      if (event.ignore && event.ignore === true) {
        return
      }

      // 지정된 엘리먼트 이벤트만 트리거
      if (inside) {
        this.$events.emit(EVENT.OBSERVER_CAPTURE_INSIDE, { event, inside })
      }
    },

    inside(event) {
      this.$log.debug(`inside event : ${event.type}`)
      this.$store.dispatch(EVENT_OBSERVERS.NAMESPACE(EVENT_OBSERVERS.SET_EVENT_CAPTURE), {
        inside: true,
        type: event.answer ? ANSWER.EVENT_TYPE : event.type,
        touch: {
          x: event.clientX,
          y: event.clientY,
        },
      })
    },

    outside(event) {
      this.$log.debug(`outside event : ${event.type}`)
      this.$store.dispatch(EVENT_OBSERVERS.NAMESPACE(EVENT_OBSERVERS.SET_EVENT_CAPTURE), {
        inside: false,
        type: event.answer ? ANSWER.EVENT_TYPE : event.type,
        touch: {
          x: event.clientX,
          y: event.clientY,
        },
      })
    },
  },
}
</script>
